import React from "react";
import RangeSliderCircle from "./rangeSliderCircle";


const roundOn = 4*100;

interface RangeSliderCircleRealValueProps {
    onUpdate: (value: number) => void;
    min: number;
    max: number;
    step: number;
    default: number;
    minPos?: number;
    maxPos?: number;
}

export default function RangeSliderCircleRealValue(props: RangeSliderCircleRealValueProps) {

    const range = props.max-props.min;

    return <RangeSliderCircle max={props.maxPos ? props.maxPos/range : undefined} min={props.minPos ? props.minPos/range : undefined} default={(props.default-props.min)/range} onUpdate={(value: number) => {
        var realValue = props.min + range*value;
        var value = value;
        if(realValue > value+props.step) {
            value = 0;
            while(value < realValue) {
                value += props.step;
            }
        }
        value = Math.round(value*roundOn)/(roundOn);
        if(value > 0 && value < props.step) {
            value = props.step;
        }
        props.onUpdate(value);
    }}/>
}